import * as d3 from 'd3'
export default {
  methods: {

    draw_Icon() {
      let items = d3.select(`#DONUT_GROUP_${this.localId}`)
      let filePath = 'https://' + this.icon.server + '.jingraphics.com/resources/' + this.icon.url

      items
      .append('image')
      .attr('id', `IMG_${this.localId}`)
      .attr('xlink:href', filePath)
      .attr('transform', `translate(${ - this.icon.width/2}, ${this.icon.y})`)

      if(this.icon.width) d3.select(`#IMG_${this.localId}`).attr('width', this.icon.width)
    },


    draw_Gauges() {
      let Gauges = this.canvasForms
      .append('g')

      let st = 0
      let an = 360
      let ro = an / this.gauge.count
      let y1 = this.donut.cy - this.gauge.radius + 4
      let y2 = y1 - (this.gauge.length * 1)
      if (this.icon.display == 'Y') { st = 225; an = 495; ro = 270 / this.gauge.count }

      for (var n = st;n < an;n += ro) {
        Gauges
        .append('line')
        .attr('x1', this.donut.cx).attr('y1', y1)
        .attr('x2', this.donut.cx).attr('y2', y2)
        .attr('stroke', this.gauge.stroke).attr('stroke-width', this.gauge.sWidth)
        .attr('transform', () => `rotate(${n},${this.donut.cx},${this.donut.cy})`)
      }
    },


    draw_Legends() {

      let legendsGroup = this.canvasForms
      .append('g')
      .attr('id', `LEGEND_GROUP_${this.localId}`)
      .attr('transform',`translate(${this.legends.x}, ${this.legends.y})`)

      if(this.legends.direct == 'horizontal') {
        let x = 0
        this.rawData.forEach((d,i)=> {
          if(d.base != 'Y'){
            let item = legendsGroup
            .append('g')
            .call(this.event_Link, this.donut.styles[i])
            
            item
            .append('rect')
            .attr('x', x).attr('y', -5)
            .attr('width', 10).attr('height', 10)
            .attr('fill', (d.color.substr(0,1) == '#') ? d.color : `url(#${this.localId}_${d.color}_)`)
            .attr('opacity', d.opacity)
            
            item
            .append('text')
            .attr('id', `LEGEND_NAME_${i}_${this.localId}`)
            .attr('x', x + 15).attr('y', .5 + this.legends.tSize*0.36)
            .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
            .text(`${d.NAME} (${d.VALUE.toFixed(this.legends.round) + this.legends.unit})`)
            
            x = x + this.getNode(`#LEGEND_NAME_${i}_${this.localId}`, 'width') + 25
          }
        })
        let groupWidth = this.legends.x - (this.getNode(`#LEGEND_GROUP_${this.localId}`, 'width') / 2)
        d3.select(`#LEGEND_GROUP_${this.localId}`).attr('transform',`translate(${groupWidth}, ${this.legends.y})`)
        } else if(this.legends.direct == 'vertical') {
          
        let y = 0
        this.rawData.forEach((d,i)=> {
          if(d.base != 'Y'){
            let item = legendsGroup
            .append('g')
            .call(this.event_Link, this.donut.styles[i])

            item
            .append('rect')
            .attr('x', 0).attr('y', y - 5)
            .attr('width', 10).attr('height', 10)
            .attr('fill', (d.color.substr(0,1) == '#') ? d.color : `url(#${this.localId}_${d.color}_)`)
            .attr('opacity', d.opacity)

            item
            .append('text')
            .attr('id', `LEGEND_NAME_${i}_${this.localId}`)
            .attr('x', 15).attr('y', y + .5 + this.legends.tSize*0.36)
            .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
            .text(`${d.NAME} (${d.VALUE.toFixed(this.legends.round) + this.legends.unit})`)
            y = y + 20
          }
        })

      }
    },

  }
}